import { DebugService } from './debug.service';

export const DebugModule = angular
  .module('sfMobile.services.debug', [
    'sfMobile.services.sentry',
    'sfMobile.services.libs',
    'sfMobile.constants',
  ])
  .service('debugService', DebugService).name;
